'use client';

import { useCallback } from 'react';
import clsx from 'clsx';
import { BURGER_MENU_ID } from '@headless-workspace/config';
import { GlowMenuButton, PropsWithClassName, PropsWithDataLayer } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { useUIContext } from '../../../../src';

type UIBurgerMenuItemProps = {
    label: string;
    id?: string;
    href: string;
    color?: string;
    hasSubCategories?: boolean;
} & PropsWithClassName &
    PropsWithDataLayer;

export const UIBurgerMenuItem: Component<UIBurgerMenuItemProps> = ({
    label,
    id,
    href,
    color,
    hasSubCategories,
    dataLayer,
    className,
}) => {
    const {
        menuModal: { navigate },
    } = useUIContext();

    const onClick = useCallback(() => {
        if (id) {
            navigate(BURGER_MENU_ID, id);
        }
    }, [id, navigate]);

    const ctaProps = hasSubCategories ? { onClick } : { href };

    return (
        <GlowMenuButton
            className={clsx('bg-background-l2 px-1 text-text-primary fill-text-primary', className)}
            label={label}
            showArrow={hasSubCategories}
            labelColor={color}
            dataLayer={dataLayer}
            {...ctaProps}
        />
    );
};
